import { Close } from '@mui/icons-material';
import { Drawer } from '@mui/material';
import OfferIcon from 'src/assets/svgExports/OfferIcon';
import { IS_DESKTOP } from 'src/utils/checkClientDeviceType';
import { GoToCartSection } from '../Common';

const ProductStrip = ({ imageUrl, name, quantity }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-[12px] tw-border-b  tw-border-dashed tw-border-[#D8D8D8] tw-p-[16px] last:tw-border-none">
      <img src={imageUrl} height={50} width={50} />
      <span className="tw-flex tw-flex-1 tw-items-center tw-justify-between ">
        <p className="tw-m-0 tw-text-[15px]/[18px] tw-font-semibold tw-text-[#414141] ">
          {name}
        </p>
        <p className="tw-m-0 tw-pr-[20px] tw-text-[15px]/[18px] tw-font-semibold tw-text-[#414141]">
          Qty: {quantity}
        </p>
      </span>
    </div>
  );
};

const RequiredBogoProductsDrawer = ({ show, onClose, products = [], offerDetails }) => {
  return (
    <Drawer
      open={show}
      onClose={onClose}
      classes={{
        paper: `${IS_DESKTOP ? 'tw-w-[30%] tw-min-w-[403px]' : 'tw-h-[468px] tw-pb-[75px]'}`,
      }}
      anchor={IS_DESKTOP ? 'right' : 'bottom'}
      transitionDuration={IS_DESKTOP ? 300 : 400}
    >
      <span
        className="tw-absolute tw-right-[24px] tw-top-[24px] tw-z-10 tw-flex tw-cursor-pointer tw-justify-center md:tw-right-[32px] md:tw-top-[42px]"
        onClick={onClose}
      >
        <Close />
      </span>
      <div
        className={`${IS_DESKTOP ? 'tw-pb-[20px] tw-pt-[42px]' : 'tw-border-b tw-border-solid  tw-border-[#D8D8D8] tw-py-[24px]'} tw-sticky tw-top-0 tw-px-[21px]`}
      >
        <h2 className={`tw-m-0  tw-text-[24px]/[32px] tw-font-bold`}>Items</h2>
        <span className="tw-text tw-m-0 tw-flex tw-items-center tw-gap-[6px] tw-pt-[4px] tw-text-[14px]/[19px] tw-font-semibold">
          <OfferIcon height={14} width={14} />
          {offerDetails?.heading}
        </span>
      </div>
      <div className="tw-flex tw-flex-col tw-overflow-scroll">
        {products.map((product, index) => (
          <ProductStrip
            key={index}
            imageUrl={product?.image_url}
            name={product?.name}
            quantity={product?.quantity}
          />
        ))}
      </div>
      <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-border-t tw-border-solid tw-border-[#D8D8D8]  tw-bg-white tw-p-[18px]">
        <GoToCartSection
          customClasses="tw-justify-between"
          primaryButtonClasses="tw-w-1/2 !tw-mr-0"
          secondaryButtonClasses="tw-w-1/2"
        />
      </div>
    </Drawer>
  );
};

export default RequiredBogoProductsDrawer;
